<template>
    <div class="container-fluid">
        <nav>
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/mypage">マイページ</router-link></li>
                <li class="breadcrumb-item">履歴</li>
            </ol>
        </nav>
        <div class="container" v-show="histories.current_page">
            <div v-if="histories.total">
                <div class="sticky">
                    <page :last_page="histories.last_page" v-model="page" @goto="goto"></page>
                </div>
                <div class="text-right">
                    <button type="button" class="btn btn-link" @click="removing = true" v-if="!removing">
                        削除
                    </button>
                    <button type="button" class="btn btn-link" @click="removing = false" v-else>
                        終了
                    </button>
                </div>
                <ul class="list-group">
                    <li class="list-group-item list-group-item-action" v-for="h in histories.data" :key="h.id">
                        <div class="row">
                            <div class="col-md-10">
                                <h5>
                                    <component
                                        :is="isInternal(h) ? 'router-link' : 'a'"
                                        :to="isInternal(h) ? getBookUri(h): null"
                                        :href="!isInternal(h) ? getBookUri(h): null"
                                        class="stretched-link">
                                        <span v-html="$filters.ruby(h.book.title)"></span>
                                    </component>
                                </h5>
                                <h6>{{h.book.subtitle}}</h6>
                                <ul class="horizontal-list small">
                                    <li>{{$filters.fromNow(h.pivot.read_at)}}</li>
                                    <li>残り{{h.remain}}話</li>
                                    <li>
                                        <span v-if="h.book.finished" class="text-success">
                                            <i class="fas fa-check-circle"></i>
                                            完結済み
                                        </span>
                                        <span v-else>連載中</span>
                                        {{h.episodes}}
                                        話
                                    </li>
                                </ul>
                            </div>
                            <div class="col-md-2 text-right">
                                <a :href="getSectionUri(h)" class="btn btn-outline-dark btn-sm stretched-link" v-if="!removing">
                                    続きから読む
                                </a>
                                <button type="button" class="btn btn-outline-danger btn-sm" v-else @click.stop="remove(h)">
                                    履歴を削除
                                </button>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div v-else class="nothing">
                履歴はありません。
            </div>
        </div>
        <loading
            v-model:active="isLoading"
            :can-cancel="false"
            :is-full-page="true"></loading>
    </div>
</template>



<script>
import page from "components/Page";
export default {
    components: {
        page
    },
    data() {
        return {
            histories: {},
            page: parseInt(this.$route.query.page) || 1,
            removing: false,
            isLoading: false,
        }
    },
    methods: {
        goto(p) {
            this.$router.push({
                query: { page: p, }
            }).catch(err => {});
        },
        load() {
            this.isLoading = true;
            this.page = parseInt(this.$route.query.page) || 1;
            axios.get("/mypage/histories/get", {params: {page: this.page}}).then(res => {
                this.histories = res.data;
                this.isLoading = false;
            }).catch(err => {
                alert.err(err.response);
                this.isLoading = false;
            });
        },
        getSectionUri(h) {
            return "//" + h.book.user.subdomain + this.$store.state.base_domain + "/author/page/"
                + h.book.id + "/section/" + h.id;
        },
        getBookUri(h) {
            let url;
            let subdomain = h.book.user.subdomain || "www";
            if (subdomain + this.$store.state.base_domain !== location.hostname) {
                url = "//" + h.book.user.subdomain + this.$store.state.base_domain + "/author/book/" + h.book.id;
            } else {
                url = "/author/book/" + h.book.id;
            }
            return url;
        },
        isInternal(h) {
            let subdomain = h.book.user.subdomain || "www";
            if (subdomain + this.$store.state.base_domain !== location.hostname) {
                return false;
            }
            return true;
        },
        remove(h) {
            this.isLoading = true;
            axios.post("/mypage/history/remove", {book_id: h.book.id}).then(res => {
                this.load();
                this.isLoading = false;
            }).catch(err => {
                alert.err(err.response);
            });
        }
    },
    watch: {
        $route(n, o) {
            this.load();
        }
    },
    mounted() {
        this.load();
        setTimeout(() => {
            this.useHead({
                title: "履歴 | 貸し本棚",
                link: [ { rel: "canonical", href: location.origin + location.pathname, id: "canonical" } ],
                meta: [
                    { name: "keywords", content: "貸し本棚,小説投稿,Web小説,小説展示,オンライン小説,縦書き小説,置き場,文芸,ライトノベル", id: "meta-keywords" },
                    { name: "description", content: "小説を書くこと、読むことにフォーカスした小説投稿サイトです。作家さん独自のサブドメインで、ご自身の小説を公開できます。横断的に編集ができるエディタで原稿執筆することも、過去の作品をレーティングを気にせず展示することもできます。", id: "meta-description" }
                ]
            });
        }, 1000);
    }
}
</script>